import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {MdDialog, MdDialogConfig, MdDialogRef, MdSnackBar} from '@angular/material';
import {AcopioSelectorDialogComponent, RemitoRequiredFilterObj, RemitosFechaSelectorComponent} from '../common';
import {RemitosFiltrosDialogComponent} from './remitos-filtros-dialog';
import {CabeceraRemitoViewModel, remitosFiltersName, RemitosService} from '@services/remitos-service';
import * as moment from 'moment';
import {RESULT_REMITOS, ResultsCacheService} from '@services/results-cache.service';
import { RemitosMotivoDialog } from '../common/remitos-motivo-dialog';
import { ColaboradoresService } from '@services/colaboradores-service';
import { AgrisAccesoRestringidoDialogComponent } from '../../../agris/common/agris-acceso-restringido-dialog/agris-acceso-restringido-dialog.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-remitos-home',
  templateUrl: './remitos-home.component.html',
  styleUrls: [
    './remitos-home.component.scss',
    '../common/remitos-common-styles.scss',
  ],
})
export class RemitosHomeComponent {
  accesoGeneral = false;
  accesoAdmin = false;
  accesoJDE = false;
  accesoTotal = false;

  remitos: CabeceraRemitoViewModel[] = [];

  loading: boolean = false;
  remitoPermisoLoading = false;
  remitoJDELoading = false;

  filtros: RemitoFilter[] = [
    {
      name: remitosFiltersName.fecha,
      value: moment().toDate().toString(),
      required: true,
    },
    { name: remitosFiltersName.acopio, value: null, required: true },
    { name: remitosFiltersName.centroEmisor, value: null, required: true },
    // { name: remitosFiltersName.numLegal, value: null, required: false },
    { name: remitosFiltersName.cliente, value: null, required: false },
  ];

  @ViewChild(RemitosFechaSelectorComponent)
  fechaSelector: RemitosFechaSelectorComponent;

  constructor(
    private dialog: MdDialog,
    private remitosService: RemitosService,
    private resultsService: ResultsCacheService,
    private colaboradoresService: ColaboradoresService,
    private router: Router,
    private snackBar: MdSnackBar,
  ) {

    this.remitoPermisoLoading = true;

    remitosService.remitosValidated.subscribe((res) => {
      this.accesoGeneral = res.AcopioPermitido || res.Admin;
      this.accesoAdmin = res.Admin;
      this.accesoRemito();
      this.remitoPermisoLoading = false;
    }, err => this.remitoPermisoLoading = false);

    this.remitoJDELoading = true;
    this.colaboradoresService.getUserJDEAccess().take(1).subscribe(x => {
      if (x !== null && x !== undefined) {
        this.accesoJDE = x.length > 0;
      }
      this.accesoRemito();
      this.openJDEError();
      this.remitoJDELoading = false;
    }, () => {
      this.accesoRemito();
      this.openJDEError();
      this.remitoJDELoading = false;
    });
  }

  accesoRemito() {
    this.accesoTotal = this.accesoJDE && this.accesoGeneral;
  }

  saveRemitosCache() {
    this.resultsService.createOrUpdateData(RESULT_REMITOS, {
      resultId: RESULT_REMITOS,
      resultJSON: '',
      resultFilter: JSON.stringify(this.filtros),
      resultURLKeywords: ['remitos', 'remito'],
    });
  }

  openSelectorAcopio() {
    let dialogRef: MdDialogRef<AcopioSelectorDialogComponent>;
    let config = new MdDialogConfig();
    config.panelClass = 'dialog-pannel-custom';
    config.width = '375px';
    dialogRef = this.dialog.open(AcopioSelectorDialogComponent, config);
    const sub = dialogRef.afterClosed().subscribe((x) => {
      sub.unsubscribe();
    });
  }

  openFilter(fil: RemitoFilter) {
    let dialogRef: MdDialogRef<RemitosFiltrosDialogComponent>;
    let config = new MdDialogConfig();
    config.panelClass = 'dialog-pannel-custom';
    config.width = '375px';
    dialogRef = this.dialog.open(RemitosFiltrosDialogComponent, config);
    dialogRef.componentInstance.nombreFiltro = fil.name;
    dialogRef.componentInstance.filter = this.filtros;

    let cache = [...this.filtros];

    const sub = dialogRef.afterClosed().subscribe((filtro) => {
      if (filtro && filtro.length) {
        this.filtros = filtro;
        if (cache !== filtro) {
          this.getRemitos();
        }
      }
      sub.unsubscribe();
    });
  }

  deleteFilter(fil: RemitoFilter) {
    if (fil.value === null) {
      this.openFilter(fil);
      return;
    }
    fil.value = null;
    // Si se elimina el filtro Acopio, eliminar Centro Emisor
    if (fil.name === remitosFiltersName.acopio) {
      let centroEmisorFilter = this.filtros.find(
        (x) => x.name === remitosFiltersName.centroEmisor
      );
      if (centroEmisorFilter) {
        centroEmisorFilter.value = null;
      }
    }
    this.getRemitos();
  }

  filterDisabled(filter: RemitoFilter) {
    switch (filter.name) {
      case remitosFiltersName.centroEmisor:
        let acopioFilter = this.filtros.find(
          (x) => x.name === remitosFiltersName.acopio
        );
        if (acopioFilter) {
          return acopioFilter.value === null;
        } else {
          return true;
        }
      default:
        return false;
    }
  }

  getFilterStyle(filter: RemitoFilter, isIcon: boolean = false): string {
    if (this.filterDisabled(filter)) {
      return 'gray-text';
    }

    if (filter.value) {
      if (isIcon) {
        return 'bold red-text';
      } else {
        return 'bold dark-gray-text';
      }
    }

    if (isIcon) {
      return 'gray-text';
    }

    return 'dark-gray-text';
  }

  allFiltersValid(): boolean {
    return !this.filtros.some(
      (filtro) => filtro.required && filtro.value === null
    );
  }

  getInfoText() {
    return this.allFiltersValid()
      ? 'Lo sentimos, no se encontraron resultados'
      : 'Para realizar la búsqueda, configurar filtros obligatorios';
  }

  createRemitoModal() {
    let dialogRef: MdDialogRef<RemitosMotivoDialog>;
    let config = new MdDialogConfig();
    config.panelClass = 'dialog-pannel-custom';
    config.width = '375px';
    dialogRef = this.dialog.open(RemitosMotivoDialog, config);

    let cache = [...this.filtros];

    const sub = dialogRef.afterClosed().subscribe((filtro) => {
      if (filtro && filtro.length) {
        this.filtros = filtro;
        if (cache !== filtro) {
          this.getRemitos();
        }
      }
      sub.unsubscribe();
    });
  }

  getRemitos() {
    this.loading = false; // Por si se estaba buscando cuando se modifica un filtro
    this.remitos = [];

    if (!this.allFiltersValid()) return;

    this.loading = true;

    this.remitosService.getListaRemitos(this.filtros).take(1).subscribe((x) => {
      if (x && x.length) {
        this.remitos = x;
        // guardamos los filtros para una nueva busqueda posterior
        this.saveRemitosCache();
      }
      this.loading = false;
    }, err => {
      this.loading = false;
      this.snackBar.open('Ha ocurrido un error al procesar la solicitud', null, {duration: 3000});
    });
  }

  onRequiredFilterChanged(e: RemitoRequiredFilterObj) {
    this.filtros.forEach((x) => {
      switch (x.name) {
        case remitosFiltersName.fecha:
          x.value = e.date;
          break;
        case remitosFiltersName.acopio:
          x.value = e.acopio;
          break;
        case remitosFiltersName.centroEmisor:
          x.value = e.centroEmisor;
          break;
      }
    });
    this.getRemitos();
  }

  onInvalidFilter() {
    // tenemos un filtro invalido, limpiamos los remitos y limpiamos los filtros requeridos
    this.remitos = [];
    this.filtros.forEach((x) => {
      if (x.required && x.name !== remitosFiltersName.fecha) {
        x.value = null;
      }
    });
  }

  parseDate(val: number) {
    return moment.unix(val).add(3, 'hours').format('DD/MM/YYYY');
  }

  openJDEError() {
    if (!this.accesoJDE && !this.remitosService.dialogWasOpen) {
      let dialogRef: MdDialogRef<AgrisAccesoRestringidoDialogComponent>;
      let config = new MdDialogConfig();
      config.panelClass = 'dialog-pannel-custom';
      config.width = '343px';
      dialogRef = this.dialog.open(
        AgrisAccesoRestringidoDialogComponent,
        config
      );
      this.remitosService.dialogWasOpen = true;
    }
  }
}

export interface RemitoFilter {
  name: string;
  value: string | number | null | any;
  required?: boolean;
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/administracion/remitos/remitos-home/remitos-home.component.ts